import { render, staticRenderFns } from "./GroupManageOptions.vue?vue&type=template&id=60d660fa&"
import script from "./GroupManageOptions.vue?vue&type=script&lang=js&"
export * from "./GroupManageOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports